import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=c56f356a&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"
import style0 from "./Edit.vue?vue&type=style&index=0&id=c56f356a&prod&scoped=true&lang=css&"
import style1 from "./Edit.vue?vue&type=style&index=1&id=c56f356a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56f356a",
  null
  
)

export default component.exports